import { useEffect } from 'react';
import { markLineOaJoined } from '../../lib/lineOa';

interface LineOaModalProps {
  /** 'tenant' = 找房場景 / 'landlord' = 出租場景 */
  mode: 'tenant' | 'landlord';
  onClose: () => void;
}

const LINE_OA_URL = 'https://line.me/R/ti/p/@381szuhf';

export default function LineOaModal({ mode, onClose }: LineOaModalProps) {
  /* 鎖定背景滾動 */
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleJoin = () => {
    markLineOaJoined(); // async, fire and forget
    window.open(LINE_OA_URL, '_blank', 'noopener,noreferrer');
    onClose();
  };

  const isTenant = mode === 'tenant';

  return (
    /* 半透明蒙版 */
    <div
      className="fixed inset-0 z-[999] flex items-end sm:items-center justify-center bg-black/50 backdrop-blur-sm px-4 pb-4 sm:pb-0"
      onClick={onClose}
    >
      {/* 卡片 */}
      <div
        className="w-full max-w-sm bg-white rounded-3xl overflow-hidden shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        {/* 頂部色塊 */}
        <div className="relative px-6 pt-7 pb-5 text-center" style={{ backgroundColor: '#06C755' }}>
          {/* 關閉按鈕 */}
          <button
            type="button"
            onClick={onClose}
            className="absolute top-3.5 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 text-white cursor-pointer hover:bg-white/30 transition-colors"
          >
            <i className="ri-close-line text-base"></i>
          </button>

          {/* LINE LOGO + 圖示 */}
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-white shadow-md">
              <i className="ri-line-fill text-4xl" style={{ color: '#06C755' }}></i>
            </div>
            <div className="text-left">
              <p className="text-white/80 text-xs font-semibold">官方帳號</p>
              <p className="text-white font-black text-lg leading-tight">藍舍 AI 地產</p>
            </div>
          </div>

          <div className="inline-flex items-center gap-1.5 bg-white/20 text-white text-xs font-bold px-3 py-1.5 rounded-full">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-300 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-300"></span>
            </span>
            {isTenant ? '有新房源時即時通知你！' : '有新租客配對成功立即通知！'}
          </div>
        </div>

        {/* 內容區 */}
        <div className="px-6 py-5">
          <h3 className="text-base font-black text-gray-900 mb-1 text-center">
            {isTenant ? '加入 LINE，不錯過任何理想房源' : '加入 LINE，即時掌握租客動態'}
          </h3>
          <p className="text-xs text-gray-500 text-center leading-relaxed mb-5">
            {isTenant
              ? 'AI 媒合到符合條件的房源時，第一時間透過 LINE 通知你，比 Email 快 10 倍！'
              : '屋主透過 LINE 收到 AI 初篩結果，快速判斷是否邀約看房，省下大量溝通時間。'}
          </p>

          {/* 功能列表 */}
          <div className="space-y-2.5 mb-5">
            {(isTenant
              ? [
                  { icon: 'ri-notification-3-line', text: '新房源上架立即 LINE 推播' },
                  { icon: 'ri-robot-2-line', text: 'AI 幫你預先篩選，只推最符合的' },
                  { icon: 'ri-shield-check-line', text: '官方帳號，絕不騷擾、不廣告' },
                ]
              : [
                  { icon: 'ri-user-search-line', text: '租客詢問後 AI 訪談結果直送 LINE' },
                  { icon: 'ri-notification-3-line', text: '配對成功即時通知，不錯過好租客' },
                  { icon: 'ri-shield-check-line', text: '官方帳號，絕不騷擾、不廣告' },
                ]
            ).map(item => (
              <div key={item.icon} className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-xl flex-shrink-0" style={{ backgroundColor: '#06C755' + '20' }}>
                  <i className={`${item.icon} text-sm`} style={{ color: '#06C755' }}></i>
                </div>
                <p className="text-sm text-gray-700 font-medium">{item.text}</p>
              </div>
            ))}
          </div>

          {/* 按鈕區 */}
          <button
            type="button"
            onClick={handleJoin}
            className="w-full py-3.5 rounded-2xl text-white font-black text-base flex items-center justify-center gap-2 cursor-pointer transition-opacity hover:opacity-90 whitespace-nowrap"
            style={{ backgroundColor: '#06C755' }}
          >
            <i className="ri-user-add-line text-lg"></i>
            立即加入 LINE 官方帳號
          </button>

          <button
            type="button"
            onClick={onClose}
            className="w-full mt-2 py-2.5 text-gray-400 text-sm font-medium cursor-pointer hover:text-gray-600 transition-colors whitespace-nowrap"
          >
            稍後再說
          </button>
        </div>
      </div>
    </div>
  );
}
